module.exports = __webpack_public_path__ + "img/香港市場向け 医薬品と健康食品の越境EC.983a969d.png";